function NewSurvey(props){

    const {cl} = props;


    return (
    
    <>
        <h1>New Survey with language {cl}

        </h1>
    </>)
}

export default NewSurvey;